import React, { useState } from 'react';
import './Hanger.css';
// import './HangerMobile.css';
import FighterPage from './Fighter/FighterPage';
import PilotPage from './Pilot/PilotPage';
import MountPage from './Mount/MountPage';



const HangerPage = ({ onClose }) => {
    const [activeTab, setActiveTab] = useState(null);

    // This function is called to "exit" a subpage, returning to the tab buttons
    const handleSubpageClose = () => setActiveTab(null);

    // Render the selected subpage if activeTab is set
    let content;
    if (activeTab === 'Fighter') {
        content = <FighterPage onClose={handleSubpageClose} />;
    } else if (activeTab === 'Pilot') {
        content = <PilotPage onClose={handleSubpageClose} />;
    } else if (activeTab === 'Crew') {
        content = <MountPage onClose={handleSubpageClose} />;
    } else {
        // Default hanger landing content
        content = <p>Select a mode above to view your hangar.</p>;
    }

    return (

            <div className="hanger-popup-container">

                <div className="hanger-top-bar">
                    <button
                        className={`hanger-top-btn${activeTab === 'Fighter' ? ' active' : ''}`}
                        onClick={() => setActiveTab('Fighter')}
                    >
                        Fighter
                    </button>
                    <button
                        className={`hanger-top-btn${activeTab === 'Pilot' ? ' active' : ''}`}
                        onClick={() => setActiveTab('Pilot')}
                    >
                        Pilot
                    </button>
                    <button
                        className={`hanger-top-btn${activeTab === 'Crew' ? ' active' : ''}`}
                        onClick={() => setActiveTab('Crew')}
                    >
                        Crew
                    </button>
                </div>
                <div className="hanger-popup-content">
                    {content}
                </div>
            </div>

    );
};

export default HangerPage;
